// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__3NHOJ","open":"modal_open__wbI9h","content":"modal_content__2xTr3","close":"modal_close__2e8jH","footer":"modal_footer__1h11_","root":"modal_root__1tHP7"};